import Alert from './alert.vue'
import Vue from 'vue';

const AlertDiv= Vue.extend(Alert);

let instance;

/**
 * 打开对话框
 * @param [option:Object] {title:'头部标题',content:'内容',OkText:'确认按钮文字',NoText:'取消按钮文字'}
 * @param [callback:function] 回调函数
 * 例子：Alert.open({title:'xxx',content:'您确定继续测试吗?',okText:'Yes',noText:'No'},(res)=>{
          if(res){
            console.log("点击确认");
          }else{
            console.log("点击取消");
          }
        })
 */

const open = function(option,callback) {
    if (!instance) {
      instance = new AlertDiv({
        el: document.createElement('div')
      });
    }
    instance.clicked = callback;
    instance.title = option.title || '温馨提示';
    instance.content = option.content;
    instance.NoText = option.noText || '';
    instance.OkText = option.okText || '确认';
    if (instance.visible) return;
    document.body.appendChild(instance.$el);
    Vue.nextTick(() => {
      instance.visible = true;
    });
};

/**
 * [close 关闭警告框]
 */
const close = function() {
   if (instance) {
     instance.visible = false;
   }
}

export default{
	open,
	close
}



// WEBPACK FOOTER //
// ./src/components/alert/index.js